'use strict';

require('vocabs')(
  exports,
  'http://ns.jasnell.me/activitystreams-ex#', 'asx',
  [
   'LanguageProperty',
   'Number',
   'Date',
   'PossiblyOrdered'
  ]
);
